import { createSlice } from "@reduxjs/toolkit";

const initialFilters = {
  bondNumber: [],
  bondType: [],
  bondSubCategory: [],
  principal: [],
  professionalGuardian: [],
  estate: [],
  lawFirm: [],
  attorney: [],
  internalUser: [],
  status: [],
  paymentStatus: [],
  startDate: null,
  endDate: null,
};

const initialState = {
  page: 0,
  filters: initialFilters,
};

const bondArchivesSlice = createSlice({
  name: "bondArchives",
  initialState,
  reducers: {
    setArchivesPage: (state, action) => {
      state.page = action.payload;
    },
    setArchivesFilters: (state, action) => {
      state.filters = action.payload || initialFilters;
    },
    resetArchivesState: (state) => {
      state.page = 0;
      state.filters = initialFilters;
    },
  },
});

export const { setArchivesPage, setArchivesFilters, resetArchivesState } = bondArchivesSlice.actions;
export default bondArchivesSlice.reducer;

